export default "__VITE_ASSET__af66a785__"